import { Link, useNavigate } from "react-router-dom";
import React, { useState } from "react";
import styled, { keyframes } from "styled-components";
import truncateText from "../../../utils/truncateText";
import { useSelector } from "react-redux";
import { decodeUserToken } from "../../../utils";
import { postAPIService } from "../../API";
import constants from "../../../constants";
import CustomizedSnackbars from "../../Shared/SnackBar";

const shimmer = keyframes`
  0% {
    background-position: -200px 0;
  }
  100% {
    background-position: calc(200px + 100%) 0;
  }
`;

// Styled Components
const Card = styled.div`
  flex: 0 0 251px;
  width: 23%;
  display: flex;
  flex-direction: column;
  cursor: pointer;
  position: relative;
  justify-content: flex-start;
  align-items: flex-start;

 @media (max-width: 601px) {
flex: 0 0 171px;
}

`;

const DiscountSticker = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #4d5c2e;
  color: #fff;
  width: 61px;
  height: 21px;
  font-size: 13px;
  position: absolute;
  left: 1rem;
  top: 1rem;
  z-index: 11;
`;

const WishlistIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  width: 33px;
  height: 33px;
  border-radius: 50%;
  position: absolute;
  right: 1rem;
  top: 1rem;
  z-index: 11;

  img {
    width: 17px;
  }
`;

const ImageContainer = styled.div`
  width: 100%;
  object-fit: cover;
  border-radius: 14px;

  img {
    width: 100%;
    aspect-ratio:1;
    object-fit: cover;
      border-radius: 7px;
  }
`;

const Info = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  margin: 0.1rem;
      white-space: pre-wrap;
`;

const ItemName = styled.div`
  color: #222;
  font-size: 15.5px;
  font-family: "Ancizar Sans", sans-serif;
  line-height: 1.2;
 
  width: 100%;
  text-align: left;

  @media (max-width: 601px) {
font-size: 12.5px;
}
`;

const PriceRow = styled.div`
  display: flex;
  width: 100%;
  color: #222;
  justify-content: flex-start;
  align-items: center;

  p:first-of-type {
    font-size: 22px;
    font-weight: 500;
    margin-left: 0.2rem;
    color:rgb(0, 98, 13);
    line-height: 1.2;
    
    margin:1px;
    white-space: break-spaces;
    font-family: "Ancizar Sans", sans-serif;
    font-weight: 500;

  }

  p:last-of-type {
    font-size: 19px;
    font-weight: 500;
    color: #999;
    margin-left: .4rem;
    text-decoration: line-through;
    padding-left: 2px;
      margin-top: unset;
      margin-bottom: unset;
    white-space: break-spaces;
    font-family: "Ancizar Sans", sans-serif;
    font-weight: 300;

      
  }
`;

const RatingRow = styled.div`

display: flex;
justify-content: flex-start;
align-items: center;
width: 100%;

p{
margin:0px;
font-size: 13px;
}
.img{
margin-right: 0.5rem;
}



`
const Button = styled.button`

width: 91px;
height: 35px;
background-color:rgb(250, 89, 25);
color: #fff;
border: none;
outline: none;
border-radius: 55px;
font-size: 12px;
cursor: pointer;
color: #fff;
margin-right: auto;
margin-left: .1rem;
margin-top: .4rem;

`

// Skeleton container with shimmer effect
const Skeleton = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #e0e0e0;
  background-image: linear-gradient(
    90deg,
    #e0e0e0 0px,
    #f5f5f5 40px,
    #e0e0e0 80px
  );
  background-size: 200px 100%;
  background-repeat: no-repeat;
  animation: ${shimmer} 1.2s infinite ease-in-out;
  border-radius: inherit;
  aspect-ratio:1;
  overflow:hidden;
`;

const CardPrice = styled.div`
display: flex;

align-items: center;
width: 100%;
justify-content: flex-start;
`

export default function CardRender2({ item ,height}) {

 const [loaded, setLoaded] = useState(false);

  const discount =
    parseInt(((item.price - item.discountedPrice) / item.price) * 100);
  const navigate = useNavigate();

  const currentProduct = useSelector(
    (state) => state.productDetails?.prodDetails || {}
  );
  const { Token = "" } = decodeUserToken();
  const [wishlistAlert, setWishListAlert] = useState({
    text: "",
    isOpen: false,
    type: "",
  });
  

  const { sku = "" } = currentProduct;
  const AddToWishListAction = async () => {
    
  

    if (!Token) {
       navigate("/login");
      setWishListAlert({
        text: "Please Login to add to Wishlist",
        isOpen: true,
        type: "error",  
      });
    }


    const URL = constants.user.AddOrRemoveWishList;
    const payload = {
      wishListType: "ADD",
      wishListItem: item.id,
    };
    const headers = { token: `${Token}`, "Content-Type": "application/json" };
    await postAPIService({ url: URL, data: payload, headers: { ...headers } })
      .then((response) => {
        const { status = 100 } = response;
        if (status === 200) {
          setWishListAlert({
            text: "Item Added to Wishlist",
            isOpen: true,
            type: "success",
          });
        }
      })
      .catch((error) => {
        console.log("wishlist_error", error);
      });
  };

  const AlertClose = () => {
    setWishListAlert({
      text: "",
      isOpen: false,
      type: "",
    });
  };

    

  return (
    <>
    <Card>
      <DiscountSticker>{discount}% off</DiscountSticker>
      <WishlistIcon onClick={AddToWishListAction}>
        <img src="/temp_images/hearticon.svg" alt="wishlist" />
      </WishlistIcon>
      <Link   to={
                          item.type === "product"
                            ? `/pd/${item?.id}`
                            : `/products/${item?.id}`
                        }
                        
                        >   <ImageContainer style={{aspectRatio:!height?"1":".7"}}>
   
                        
                        {!loaded && <Skeleton style={{aspectRatio:!height?"1":".7"}} />}
                        <img style={{aspectRatio:!height?"1":".7"}} src={`${item.imageUrl}`} alt={item.name} 
                        
                           onLoad={() => setLoaded(true)}
                           loaded={loaded}
                        
                        />
      </ImageContainer></Link>

      <Info>
        <ItemName>{truncateText(item.name,45)}</ItemName>
        <PriceRow>
          
          <p>₹ {item.discountedPrice}</p>
          <p>₹ {item.price}</p>
        </PriceRow>

        <RatingRow>
          <img
            src="/temp_images/star.png"
            alt="rating"
            style={{ width: "15px",height:'15px', marginRight: "0.2rem",aspectRatio:1 }}
          />
          <p style={{ fontSize: "13px", color: "#444" }}>
            {item.rating?item.rating:'-'} {item.rating_count?item.rating_count:'not rated'}
          </p>
        </RatingRow>

       {/*  <Button>
          Add to Cart
        </Button> */}


      </Info>
      
    </Card>
      {wishlistAlert?.isOpen && (
              <CustomizedSnackbars {...wishlistAlert} AlertClose={AlertClose} />
            )}
            </>
  );
}
